export default __webpack_public_path__ + "static/mediaBGTop-69c4c739b9a5f4c7939422a6c59ecd0b.jpg";